import { Button } from 'antd-mobile'
import { getWechatAuthUrl } from '@mkmp/core'
import '../styles/unauth.scss'
/**
 * 未授权页面
 * @returns
 */
export const UnAuth = () => {
  /**
   * 跳转微信授权
   */
  const toAuth = () => {
    const authUrl =
      process.env.API_SUP_URL + '/wechat/authorize?redirect=' + encodeURIComponent(window.location.origin + '/vendor')

    window.location.replace(
      getWechatAuthUrl(process.env.APP_WECHAT_ID || '', encodeURIComponent(authUrl), 'snsapi_userinfo')
    )
  }

  return (
    <div className="unauth">
      <div className="unauth-content">
        <header>
          <span className="unauth-icon"></span> 您尚未授权
        </header>
        <div className="unauth-content__tip">授权用户信息后，将获得更多操作权限</div>
        <div className="unauth-content__btn">
          <Button color="primary" onClick={toAuth}>
            立即授权
          </Button>
        </div>
      </div>
    </div>
  )
}
